export const isSupplierPortal = () => {
    const { hostname } = window.location;
    // Extract the first part of the hostname (subdomain)
    const firstPart = hostname.split(".")[0];
    // Check if the first part ends with "portal"
    return firstPart.endsWith("supplier");
};

export const isClientPortal = () => {
    const { hostname } = window.location;
    // Extract the first part of the hostname (subdomain)
    const firstPart = hostname.split(".")[0];
    // Check if the first part ends with "portal"
    return firstPart.endsWith("client");
};
